import { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router";
import CasinoHeading from "../../casinoComponents/casinoHeading";
import BetTableTeenPatti20c from "../../casinoComponents/betTableTeenPatti20c";
import VideoBox from "../../casinoComponents/videoBox";
import CasinoLastResult from "../../casinoComponents/casinoLastResult";
import CasinoTableLayout from "../../casinoComponents/casinoTableLayout";
import ViewMoreModal from "../../../components/ViewMoreModal";
import {
  getCasinoGameDetails,
  getMatchExposure,
  getCasinoOpenBets,
} from "../../../apiservices/CasionApi";
import { extractCasinoGame } from "../../../utils/casinoGame";
import Teen20RefCardsOverlay from "../../casinoComponents/videoBox/overlays/Teen20RefCardsOverlay";
import Teen20RefResults from "../resultui/resultTeen20/Teen20RefResults";
import Teen20RightSide from "../teen20/Teen20RightSide";
import "../../../styles/games/teen20.css";


export default function TeenPatti20b() {
  const [gameData, setGameData] = useState({});
  const [iframeSrc, setIframeSrc] = useState("");
  const { pathname } = useLocation();
  const gameName = extractCasinoGame(pathname) || "teen20b";
  const [playerAData, setPlayerAData] = useState([]);
  const [playerBData, setPlayerBData] = useState([]);
  const [exposures, setExposures] = useState({});
  const [myBets, setMyBets] = useState([]);
  const [showViewMoreModal, setShowViewMoreModal] = useState(false);

  useEffect(() => {
    const name = extractCasinoGame(pathname) || "teen20b";
    setIframeSrc(`https://stream-s-43.uhdmovies.online/casino-stream?id=${name}`);

    const fetchGameData = async () => {
      try {
        const response = await getCasinoGameDetails(name);
        setGameData(response || {});
      } catch (err) {
        console.error("Error fetching game data:", err);
      }
    };

    fetchGameData();
    const interval = setInterval(fetchGameData, 1500);
    return () => clearInterval(interval);
  }, [pathname]);

  useEffect(() => {
    const subData = gameData?.data?.data?.sub || [];
    if (Array.isArray(subData) && subData.length > 0) {
      setPlayerAData(subData.filter((item) => item?.nat?.endsWith("A")));
      setPlayerBData(subData.filter((item) => item?.nat?.endsWith("B")));
    }
  }, [gameData?.data?.data?.sub]);

  const handleBetClick = (value, selection, betData, tablePlayerName) => {
    if (!value) return;
    fetchExposure();
    fetchMyBetsData();
  };

  const fetchExposure = useCallback(async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const userId = user?.user_id || user?.id || user?.staff_id || user?.owner_id;
      const matchId = gameData?.data?.data?.mid?.toString();

      if (userId && matchId) {
        const response = await getMatchExposure(userId, matchId);
        if (response.success && response.data) {
          const exposureMap = {};
          response.data.forEach((item) => {
            const teamName = item.team_name || item.selection || item.player_name || "";
            const exposureAmount = parseFloat(item.exposure_amount) || 0;
            if (teamName && exposureAmount !== 0) {
              exposureMap[teamName] = exposureAmount;
              exposureMap[teamName.toLowerCase()] = exposureAmount;
              exposureMap[teamName.trim()] = exposureAmount;
            }
          });
          setExposures(exposureMap);
        }
      }
    } catch (error) {
      console.error("Error fetching exposure:", error);
    }
  }, [gameData?.data?.data?.mid]);

  const fetchMyBetsData = useCallback(async () => {
    if (!gameName) return;
    try {
      const response = await getCasinoOpenBets(gameName);
      if (response?.success && Array.isArray(response.data)) {
        const formattedBets = response.data.map((bet) => ({
          // My Bets "Gametype" column (casino_bets.game_name, e.g. mogambo)
          description: bet.description ?? bet.game_name ?? bet.gameName,
          userName: bet.username || bet.userName || "-",
          matchedBet: bet.matchedBet || bet.nation || bet.selection || bet.player_name || "-",
          selection: bet.selection || bet.player_name || bet.matchedBet || "",
          player_name: bet.player_name || "",
          odds: bet.odds ?? bet.userrate ?? "0",
          stake: bet.stake ?? bet.amount ?? "0",
          placeDate: bet.placeDate ?? bet.created_at ?? "-",
          gametype: bet.gametype ?? bet.game_type ?? (bet.type === "lay" ? "Lay" : bet.type === "back" ? "Back" : "-"),
          type: bet.type || null,
          exposer: parseFloat(bet.exposer || bet.exposure_amount || "0") || 0,
        }));
        setMyBets(formattedBets);
      }
    } catch (error) {
      console.error("Error fetching my bets (open-downline):", error);
    }
  }, [gameName]);

  useEffect(() => {
    const matchId = gameData?.data?.data?.mid?.toString();
    if (matchId) {
      const t = setTimeout(() => fetchExposure(), 2000);
      const exposureInterval = setInterval(fetchExposure, 2000);
      return () => {
        clearTimeout(t);
        clearInterval(exposureInterval);
      };
    }
  }, [gameData?.data?.data?.mid, fetchExposure]);

  useEffect(() => {
    fetchMyBetsData();
    const intervalId = setInterval(fetchMyBetsData, 3000);
    return () => clearInterval(intervalId);
  }, [fetchMyBetsData]);

  const d = gameData?.data?.data;
  const roundId = d?.t1?.gmid || d?.mid || gameData?.data?.mid || gameData?.mid || "";
  // Reference title (gameTitle "20-20 Teenpatti B")
  const title = "20-20 Teenpatti B";

  // Reference markup: .casino-table.teenpatti20 > .game-header + .casino-video (cards without
  // player headings) + .casino-detail > .teen20casino-container + Last Result; right sidebar
  // My Bets + Pair Plus rules card — same template as 20-20 Teenpatti.
  return (
    <CasinoTableLayout
      tableClass="teenpatti20"
      rightSide={<Teen20RightSide bets={myBets} onViewMore={() => setShowViewMoreModal(true)} />}
    >
      <>
        <CasinoHeading name={title} roundId={roundId} />
        <VideoBox
          gameType={gameName}
          resultData={d?.card}
          iframeSrc={iframeSrc}
          timerValue={d?.lt}
          cardsOverlay={<Teen20RefCardsOverlay cards={d?.card} showNames={false} />}
        />
        {d?.mid ? (
          <div className="casino-detail">
            <div className="teen20casino-container d-none-small">
              <div className="teen20left">
                <BetTableTeenPatti20c
                  data={playerAData}
                  onBetClick={(value, selection, betData) => handleBetClick(value, selection, betData, "A")}
                  playerName="A"
                  exposures={exposures}
                  lockTopBook
                />
              </div>{" "}
              <div className="teen20center" />{" "}
              <div className="teen20right">
                <BetTableTeenPatti20c
                  data={playerBData}
                  onBetClick={(value, selection, betData) => handleBetClick(value, selection, betData, "B")}
                  playerName="B"
                  exposures={exposures}
                  lockTopBook
                />
              </div>
            </div>{" "}
            <CasinoLastResult
              gameType={gameName}
              resultComponent={<Teen20RefResults gameType={gameName} fallbackTitle={title} />}
            />
          </div>
        ) : null}
      </>
      <ViewMoreModal
        show={showViewMoreModal}
        onHide={() => setShowViewMoreModal(false)}
        title="View More"
        sectionKey={gameName}
      />
    </CasinoTableLayout>
  );
}
